import { c as _c } from "react/compiler-runtime";
import type { UnresolvedLink } from "contentful";
import { isEntryOfContentType } from "@/lib/contentful/guards";
import { cn } from "@/lib/utils";
import CardItem, { type CardEntry } from "./CardItem";
interface Props {
  items: (UnresolvedLink<"Entry"> | CardEntry)[];
  heading?: string;
}
export default function CardRow(t0) {
  const $ = _c(18);
  const {
    items,
    heading
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== heading || $[1] !== items) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const cards = (items ?? []).filter(_temp);
      if (cards.length === 0) {
        console.warn("Skipping rendering Card Section because there are no valid Cards.");
        t5 = null;
        break bb0;
      }
      t3 = "flex flex-col gap-6 py-6 w-full max-w-site-content mx-auto px-6";
      if ($[7] !== heading) {
        t4 = heading && <h2 className="heading-lg">{heading}</h2>;
        $[7] = heading;
        $[8] = t4;
      } else {
        t4 = $[8];
      }
      const t6 = cards.length === 3 ? "md:grid-cols-3" : "md:grid-cols-4";
      if ($[9] !== t6) {
        t1 = cn("grid grid-cols-1 gap-6", t6);
        $[9] = t6;
        $[10] = t1;
      } else {
        t1 = $[10];
      }
      t2 = cards.map(_temp2);
    }
    $[0] = heading;
    $[1] = items;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t6) {
    t7 = <section className={t3}>{t4}{t6}</section>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}
function _temp2(card) {
  return <CardItem key={card.sys.id} card={card} />;
}
function _temp(item) {
  return isEntryOfContentType(item, "card");
}